<template>
  <div class="d-flex flex-row status-container">
    <slot
      v-bind:isSnoozed="!!snoozedUntil"
      v-bind:emailStatus="emailStatus"
      v-bind:titleStatus="titleStatus"
      v-bind:status="status"
      v-bind:isFollowUp="referral.requires_followup && referral.is_incoming"
      v-bind:meta="meta"
    >
      <div :class="{ '_opacity-50': !!isArchived }">
        <div class="d-flex align-items-center font-weight-bolder mb-0">
          <template v-if="isArchived">
            Snoozed<span v-if="timeUntilSnooze">&nbsp;for&nbsp;</span>
            <vue-countdown
              v-if="timeUntilSnooze"
              :time="timeUntilSnooze"
              v-slot="{ hms, hours, minutes, seconds }"
              class="ml-2"
              :transform="transformCountdownSlotProps"
            >
              <h4 class="font-weight-bolder mb-0" style="font-size: 1.5rem">{{ hms }}</h4>
            </vue-countdown>
            <a href="javascript:void(0)" @click="unsnooze" class="font-weight-normal ml-2" style="font-size: 0.85rem"
              >unsnooze</a
            >
          </template>
          <template v-else>
            <template v-if="statusIndex == 1 && referral.is_incoming">
              <!-- <vue-countdown v-if="timeUntilAction" :time="timeUntilAction" v-slot="{ hms, hours, minutes, seconds }" class="mr-3" :transform="transformCountdownSlotProps">
              <h1 class="font-weight-bolder mb-0" style="font-size:2.5rem;width:4.5em">{{ hms }}</h1>
            </vue-countdown> -->
              <h1 v-if="elapsedTime" class="font-weight-bolder mb-0" style="font-size: 2.5rem; width: 5em">
                {{ elapsedTime }}
              </h1>
              {{
                elapsedTime
                  ? 'Elapsed without update'
                  : `${$helpers.doctor(referral)} has been notified that no action was taken`
              }}
            </template>
            <template v-else>
              <font-awesome-icon
                v-if="titleStatus == 'Completed'"
                size="lg"
                :icon="['fas', 'check-circle']"
                class="text-primary mr-2 mt-1"
              />
              <span class="title d-block d-lg-none" v-html="status"></span>
              <span class="title d-none d-lg-block" v-html="titleStatus"></span>
              <template v-if="meta">
                <span class="mx-1 d-block d-md-inline">•</span>
                <span class="text-muted font-weight-normal d-block d-md-inline">{{ meta }}</span>
              </template>

              <template v-else-if="referral.is_marked_scheduled && statusIndex === 4 && referral.is_incoming">
                <span class="mx-1 d-block d-md-inline">•</span>
                <!-- <span class="text-muted font-weight-normal d-block d-md-inline">No appointment time</span> -->

                <scheduled-button :referral="referral" v-if="!isOrganization" class="mt-1">
                  <small>
                    <a href="#" class="font-weight-normal d-block d-md-inline" style="font-size: 1rem"
                      >Set appointment time</a
                    ></small
                  >
                </scheduled-button>
              </template>
              <!-- <template v-if="emailStatus">
                <span class="mx-1 d-block d-md-inline">•</span>
                <span class="text-muted font-weight-normal d-block d-md-inline">Email {{ emailStatus }}</span></template> -->
            </template>
          </template>
        </div>
        <div v-if="showIndicator" class="status-indicator" :class="['status-' + stateIndex]">
          <div class="status-indicator-step" :class="[stateIndex >= 1 ? 'active-' + stateIndex : '']"></div>
          <div class="status-indicator-step" :class="[stateIndex >= 2 ? 'active-' + stateIndex : '']"></div>
          <div class="status-indicator-step" :class="[stateIndex > 2 ? 'active-' + stateIndex : '']"></div>
        </div>
      </div>
      <div v-if="referral.requires_followup && referral.is_incoming">
        <span
          class="badge badge-sm ml-2 p-2"
          :class="[
            !referral.is_incoming && !referral.followup_completed_time ? 'badge-warning text-white' : 'badge-light',
          ]"
          >F/UP</span
        >
      </div>
    </slot>
  </div>
</template>

<script>
const STATUSES = {
  'Not Sent': '#012B30',
  Referred: '#012B30',
  'Referred - Manual': '#012B30',
  Scheduling: '#012B30',
  Scheduled: '#012B30',
  'In Progress': '#012B30',
  Cancelled: '#D74E4E',
  Completed: '#012B30',
  Archived: '##EFF3F3',

  // Cancelled', 'Completed', 'Not Sent', 'Scheduled', 'Referred - Manual', 'Referred
}
import moment, { min } from 'moment'
import { mapGetters } from 'vuex'
import ScheduledButton from '@/components/referrals/ScheduleButton'
import VueCountdown from '@chenfengyuan/vue-countdown'
export default {
  components: { ScheduledButton, VueCountdown },
  props: {
    referralId: { required: true },
    showIndicator: { type: Boolean, default: true },
  },
  data() {
    return {
      now: moment.utc(),
      timeInterval: null,
    }
  },
  mounted() {
    if (!Object.keys(STATUSES).includes(this.status))
      throw new Error(`Invalid status: ${this.status}. Must be snoozed or: ${Object.keys(STATUSES).join(', ')}`)

    this.timeInterval = setInterval(() => (this.now = moment.utc()), 1000)
  },
  destroyed() {
    if (this.timeInterval) clearInterval(this.timeInterval)
  },
  computed: {
    ...mapGetters('auth', ['isOrganization']),
    ...mapGetters('referrals', ['all', 'get']),
    referral() {
      return this.get(this.referralId)
    },
    isIncoming() {
      return this.referral.is_incoming
    },
    status() {
      return this.$helpers.getStatus(this.referral, true)
    },
    snoozedUntil() {
      return this.$helpers.isSnoozed(this.referral)
    },
    isArchived() {
      return this.$helpers.isArchived(this.referral)
    },
    color() {
      return STATUSES[this.status]
    },
    statusIndex() {
      return this.$helpers.getStatusIndex(this.referral)
    },
    emailStatus() {
      var tp = this.referral.to_practice
      if (tp && (tp.status != 1 || tp.is_example) && this.referral.last_email_status_time)
        switch (this.referral.last_email_status) {
          case 'unsent':
          case 'sent':
            return 'sent'
          case 'delivered':
            return 'delivered'
          case 'opened':
          case 'clicked':
            return 'viewed'
          case 'bounced':
          case 'failed':
            return 'Email delivery issue'
        }
    },
    meta() {
      switch (this.statusIndex) {
        case 3:
          return moment(this.referral.requested_scheduled_time).format('M/D [at] h:mm A').replace(':00', '')
        case 4:
          return this.referral.scheduled_time && this.$helpers.calDate(this.referral.scheduled_time)
      }
    },
    titleStatus() {
      switch (this.statusIndex) {
        case 0:
          return "You haven't sent this referral"
        case 1:
          if (this.referral.is_important || 1 == 1) {
            if (this.isIncoming) {
              return `Please call ${this.referral.patient_firstname} ${
                this.referral.patient_lastname[0]
              } on ${this.$options.filters.phone(this.referral.patient_phone)} `
            }
            // if (
            //   this.referral.last_email_status == 'opened' ||
            //   this.referral.last_email_status == 'clicked'
            // )
            //   //todo: need to check if receiver has opened link without viewing email
            //   return `${this.referral.to_practice.name} have viewed this referral`

            // if (this.referral.to_practice.status != 1)
            //   if (this.referral.last_email_status == 'delivered')
            //     return `${this.referral.to_practice.name} have received this referral`
            // if (this.referral.last_email_status == 'delivered')
            //   return `Waiting for updates from ${this.referral.to_practice.name}`

            // if (this.referral.is_sending)
            //   return `Sending to ${this.referral.to_practice.name}...`

            if (this.referral.patient_called_on) return `${this.referral.to_practice.name} has contacted the patient`
          }
          return this.referral.receiver_viewed_at_time
            ? `${this.referral.to_practice.name} has viewed this referral`
            : `${this.referral.to_practice.name} has not yet viewed this referral`

        case 3:
          return 'Appointment request'
        case 4:
          return 'Scheduled'
        case 5:
          if (this.now.diff(this.referral.scheduled_time, 'minutes') < 60) return `Treatment in progress`
          return this.referral.is_incoming
            ? `Has ${this.referral.patient_firstname}'s treatment been completed?`
            : 'Waiting for completion'
        case 6:
          return 'Cancelled'
        case 7:
          return this.referral.requires_followup && !this.isIncoming && !this.referral.followup_completed_time
            ? 'You need to follow up with this referral'
            : 'Completed'
        case 8:
          return 'Snoozed'
      }
    },
    stateIndex() {
      const status = this.status
      if (status === 'Referred') return 1
      if (status === 'In Progress' || status === 'Scheduled' || status === 'Scheduling') return 2
      if (status === 'Completed') return 3
      if (status === 'Cancelled') return 4

      return 0
    },
    bg() {
      return this.color + '26'
    },
    fg() {
      return this.color
    },
    dotStyle() {
      return `border: 5px solid ${this.fg};`
    },

    timeUntilAction() {
      if (this.$helpers.isSchedulable(this.referral) && this.referral.is_incoming) {
        return this.now.diff(this.referral.sent_time, 'milliseconds')
      }
    },
    timeUntilSnooze() {
      return this.snoozedUntil && this.snoozedUntil.diff(this.now, 'milliseconds')
    },
    elapsedTime() {
      try {
        const diff = this.now.diff(this.referral.receiver_viewed_at_time || this.referral.sent_time)
        const msDiff = moment.duration(diff).asSeconds()
        return msDiff >= 96 * 3600 ? null : this.toHHMMSS(msDiff) //new Date(msDiff).toISOString().substr(11, 8)
        const fDiff = moment.utc(diff).format('HH:mm:ss')
        return fDiff
      } catch (e) {
        console.error(e)
        this.$exception(e)
      }
    },
  },
  methods: {
    toHHMMSS(secs) {
      var sec_num = parseInt(secs, 10)
      var hours = Math.floor(sec_num / 3600)
      var minutes = Math.floor(sec_num / 60) % 60
      var seconds = sec_num % 60
      return (
        [hours, minutes, seconds]
          .map((v) => (v < 10 ? '0' + v : v))
          // .filter((v, i) => v !== '00' || i > 0)
          .join(':')
      )
    },

    async unsnooze() {
      const _this = this
      let item = { ...this.referral }

      item[`snooze_until_${!item.is_incoming ? 'from' : 'to'}_time`] = null
      item[`archived_${!item.is_incoming ? 'from' : 'to'}_time`] = null

      try {
        await this.$store.dispatch('referrals/save', item)
      } catch (err) {
        this.$exception(err)
      }
    },
    transformCountdownSlotProps(props) {
      const formattedProps = {}

      Object.entries(props).forEach(([key, value]) => {
        formattedProps[key] = value < 10 ? `0${value}` : String(value)
      })

      // formattedProps['hours'] += formattedProps['days'] * 24
      const hms =
        formattedProps.days == 0
          ? `${formattedProps.hours}:${formattedProps.minutes}:${formattedProps.seconds}`.replace('00:', '')
          : `${formattedProps.days} days`
      // .replace(':00', '')
      return { ...formattedProps, hms }
    },
  },
}
</script>

<style scoped lang="scss">
.tag {
  border-radius: 12px;
  width: fit-content;
  font-size: 0.9em;
}
.circle {
  display: block;
  border-radius: 10px;
  width: 10px;
  height: 10px;
}
.title {
  letter-spacing: -0.02rem;
}
.status-indicator {
  display: flex;
  width: 100%;
  .status-indicator-step {
    flex: 1;
    min-width: 0;
    margin: 0 0.5em;
    border: 3px solid #eef0f2;
    height: 5px;
    &:first-child,
    &:last-child {
      margin: 0;
    }

    &.active-1 {
      border-color: var(--info-color);
    }
    &.active-2 {
      border-color: var(--info-color);
    }
    &.active-3 {
      border-color: var(--success-color);
    }
    &.active-4 {
      border-color: var(--danger-color);
    }
  }
  .status-indicator-step.active {
  }
}
.badge {
  border-radius: 10px;
}
@media (min-width: 962px) {
  .status-indicator {
    width: calc(120px + 1em);
  }
  // .status-container {
  //   max-width: 20vw;
  // }
}
@media (min-width: 962px) {
}
</style>
